import React from 'react';

import { useI18n } from '@change-corgi/core/react/i18n';

import type { PageHeaderToolbarProps } from '../../types';

import { ActionButton } from './components/ActionButton';
import { toolbar as toolbarStyles } from './PageHeaderToolbar.styles';

export const PageHeaderToolbar: React.FC<PageHeaderToolbarProps> = ({
	actionButtons = [],
	mobile = false,
	buttonVariant = 'default',
}: PageHeaderToolbarProps) => {
	const styles = toolbarStyles({ isMobile: mobile, buttonVariant });
	const { translate } = useI18n();
	return (
		<nav
			className={styles}
			data-testid="page-header-actions"
			aria-label={translate('corgi.petition.starter_dashboard_v2.page_header_toolbar.page_actions.aria_label')}
		>
			{actionButtons.map((buttonType) => (
				<ActionButton
					data-testid={`header-button-${buttonType}`}
					data-qa={`header-button-${buttonType}`}
					key={`header-button-${buttonType}`}
					actionType={buttonType}
					variant={buttonVariant}
				/>
			))}
		</nav>
	);
};
